import { css, cssManager } from '@design.estate/dees-element';
import { DeesInputBase } from '../dees-input-base/dees-input-base.js';

export const datepickerStyles = [
    ...DeesInputBase.baseStyles,
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        position: relative;
      }

      .input-container {
        position: relative;
        width: 100%;
      }

      .date-input {
        width: 100%;
        height: var(--dees-input-height);
        padding: 0 12px;
        text-align: var(--dees-input-control-align, left);
        border-radius: var(--dees-radius-lg);
        corner-shape: var(--dees-corner-shape);
        font-size: var(--dees-font-control-size);
        line-height: 1.5;
        color: var(--dees-color-text-primary);
        cursor: pointer;
        transition:
          border-color var(--dees-transition-fast) var(--dees-ease-standard),
          box-shadow var(--dees-transition-fast) var(--dees-ease-standard),
          background-color var(--dees-transition-fast) var(--dees-ease-standard);
        outline: none;
        font-family: var(--dees-font-family);
      }

      .date-input::placeholder {
        color: var(--dees-color-text-muted);
      }

      .date-input[aria-invalid="true"] { border-color: var(--dees-color-accent-error); }
      .field-messages { grid-column: 1 / -1; }
      .validationText { color: var(--dees-color-text-error); font-size: var(--dees-font-footnote-size); }
      .validationText:not(:empty) { margin-top: var(--dees-spacing-xs); }

      .date-input:hover:not(:disabled) {
        border-color: var(--dees-color-border-strong);
      }

      .date-input:focus,
      .date-input.open {
        border-color: var(--dees-color-focus-ring);
        outline: 2px solid var(--dees-color-focus-ring);
        outline-offset: 1px;
      }

      .date-input:disabled {
        background: var(--dees-color-badge-default-bg);
        color: var(--dees-color-label-quaternary);
        cursor: not-allowed;
      }

      .icon-container {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0 12px;
        pointer-events: none;
      }

      .icon-container > * {
        pointer-events: auto;
      }

      .calendar-icon {
        color: var(--dees-color-text-muted);
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .clear-button {
        width: 20px;
        height: 20px;
        border: none;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: var(--dees-color-text-muted);
        transition: opacity 0.2s ease, background-color 0.2s ease;
        padding: 0;
        flex-shrink: 0;
      }

      .clear-button:hover {
        background: var(--dees-color-badge-default-bg);
        color: var(--dees-color-text-primary);
      }
      @media (pointer: coarse) {
        .icon-container { padding: 0 8px; }
        .clear-button { min-width: 44px; min-height: 44px; }
      }
    `,
  ];
